import CustomRoutes from './navigation/CustomRoutes'
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { microsoftconfig } from "./component/pages/config";

const msalInstance = new PublicClientApplication({
  auth: {
    clientId: microsoftconfig.appId, 
    redirectUri: microsoftconfig.redirectUri,
  }
})

function App() {
  return (
      <MsalProvider instance={msalInstance}>
      <CustomRoutes />
      </MsalProvider>
  );
}

export default App;